import React from 'react';
import PropTypes from 'prop-types';
import { SelectPicker } from 'rsuite';

function SelectInput(props) {

  return (
    <div className={props.wrapperClass}>
      {<label className={props.labelClass} htmlFor="{props.id}">{props.label}</label>}
      <SelectPicker
        onOpen={props.onOpen}
        onClose={props.onClose}
        className={props.selectPickerClass}        
        appearance="default"
        placement="topStart"
        preventOverflow
        data={props.options}
        id={props.id}
        name={props.name}
        searchable={props.searchable}
        groupBy={props.groupBy}
        placeholder={props.firstOption}
        labelKey={props.labelKey || "name"} valueKey={props.valueKey || "id"}
        value={props.value || ""}
        onChange={(e) => { props.onChange(props.name, e) }}
      />
      {props.error.length > 0 && <div className="alert alert-danger">{props.error}</div>}
    </div>
  );
}


// Define what props this element has (for debugging purposes only)
SelectInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  groupBy: PropTypes.string,
  //value: PropTypes.string,
  //options: PropTypes.arrayOf(PropTypes.shape({
  //  id: PropTypes.string.isRequired,
  //  name: PropTypes.string.isRequired,
  //})).isRequired,
  error: PropTypes.string,
}

SelectInput.defaultProps = {
  error: "",
  value: "",
  firstOption: ""
}


export default SelectInput;